import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { CharacteristicModel } from '../../../common/viewModels/Analysis/SampleModel';
import { UnitsModel } from '../../../common/viewModels/GlobalRegistry/UnitsModel';
import { OilGradeCharModel } from '../../../common/viewModels/ReportConfig/productgradesModel';
import { CharRatingTypes } from '../../../common/enumcontainer.enum';
@Component({
  selector: 'addproductgrades',
  templateUrl: './addproductgrades.component.html',
  styleUrls: ['./addproductgrades.component.scss']
})
export class AddProductGradesComponent implements OnInit {
  charRtngTypes: any;
  productGradesForm: FormGroup;
  isSubmitted: boolean = false;
  lstUnits: UnitsModel[];
  lstCharacteristics: CharacteristicModel[];
  lstCharValues: any[];
  lstCharCompTypes: any[];
  oilGradeChars: any[];
  isFormValid: boolean = true;

  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService) {
    ;
  }

  ngOnInit() {
    this.charRtngTypes = CharRatingTypes;
    this.productGradesForm = this._formBuilder.group({
      OilGradeId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(100)])],
      Description: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100)])],
      AliasName: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      Brand: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      LstOilGradeChars: [],
    });
    let id = this._route.snapshot.params['id'];
    this.GetProductGradeById(id);
    this.GetUnitsForDDL();
    this.GetCharValueTypes();
    this.GetCharSpecComparisionTypes();
  }

  GetUnitsForDDL() {
    //this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetUnitsForDDL)
      .subscribe(
        data => {
          this.lstUnits = data.json().Result;
          //this._mApp.HideLoader();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetCharacteristicsForDDL() {
    //this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCharacteristics)
      .subscribe(
        data => {
          this.lstCharacteristics = data.json().Result;
          //this._mApp.HideLoader();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetCharValueTypes() {
    //this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCharValueTypes)
      .subscribe(
        data => {
          this.lstCharValues = data.json().Result;
          //this._mApp.HideLoader();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetCharSpecComparisionTypes() {
    //this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCharSpecComparisionTypes)
      .subscribe(
        data => {
          this.lstCharCompTypes = data.json().Result;
          //this._mApp.HideLoader();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetProductGradeById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetPrdGrdById + this._route.snapshot.params['id'])
      .subscribe(
        data => {
          if (data.json() != null) {
            this._mApp.HideLoader();
            this.productGradesForm.setValue(data.json().Result);
            this.lstCharacteristics = data.json().Result.LstOilGradeChars;
            this.oilGradeChars = data.json().Result.LstOilGradeChars;
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  onSubmit() {
    this.ValidateFormValues(this.oilGradeChars);
    this.isSubmitted = true;
    if (this.productGradesForm.valid && this.isFormValid) {
      let prodGrdDto = this.productGradesForm.value;
      prodGrdDto.LstOilGradeChars = this.oilGradeChars;
      this._mApp.ShowLoader();
      this._http.post(this._appUrl.AddEditPrdGrd, prodGrdDto)
        .subscribe(
          data => {
            this._mApp.HideLoader();
            this._toastrService.success(data.json().Result, '');
            this._router.navigate(['/productgradeslist']);
          },
          error => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, '');
          }
        );
    }
  }

  Clear() {
    this.productGradesForm.reset();
  }


  ValidateFormValues(oilGradeChars) {
    for (let item of oilGradeChars) {
      let val1 = item.NormalValue1;
      let val2 = item.NormalValue2;
      let valType = Number(item.NormalCharValueTypeId);
      if ((val1 != null && val1 != '') || (val2 != null && val2 != '')) {
        if (valType === 0) {
          this.isFormValid = false;
          this._toastrService.warning("Please select type in normal limits for " + item.Name)
          return;
        }
        else
          this.isFormValid = true;
      }

      val1 = item.WarningLowerValue1;
      val2 = item.WarningLowerValue2;
      valType = Number(item.WarningLowerCharValueTypeId);
      if ((val1 != null && val1 != '') || (val2 != null && val2 != '')) {
        if (valType === 0) {
          this.isFormValid = false;
          this._toastrService.warning("Please select type in caution - limits for " + item.Name)
          return;
        }
        else
          this.isFormValid = true;
      }

      val1 = item.WarningUpperValue1;
      val2 = item.WarningUpperValue2;
      valType = Number(item.WarningUpperCharValueTypeId);
      if ((val1 != null && val1 != '') || (val2 != null && val2 != '')) {
        if (valType === 0) {
          this.isFormValid = false;
          this._toastrService.warning("Please select type in caution + limits for " + item.Name)
          return;
        }
        else
          this.isFormValid = true;
      }

      val1 = item.CriticalLowerValue1;
      val2 = item.CriticalLowerValue2;
      valType = Number(item.CriticalLowerCharValueTypeId);
      if ((val1 != null && val1 != '') || (val2 != null && val2 != '')) {
        if (valType === 0) {
          this.isFormValid = false;
          this._toastrService.warning("Please select type in critical - limits for " + item.Name)
          return;
        }
        else
          this.isFormValid = true;
      }

      val1 = item.CriticalUpperValue1;
      val2 = item.CriticalUpperValue2;
      valType = Number(item.CriticalUpperCharValueTypeId);
      if ((val1 != null && val1 != '') || (val2 != null && val2 != '')) {
        if (valType === 0) {
          this.isFormValid = false;
          this._toastrService.warning("Please select type in critical + limits for " + item.Name)
          return;
        }
        else
          this.isFormValid = true;
      }
    }
  }

}
